import { render } from "./navbarComp.vue?vue&type=template&id=c74f24ec&scoped=true"
import script from "./navbarComp.vue?vue&type=script&lang=js"
export * from "./navbarComp.vue?vue&type=script&lang=js"

import "./navbarComp.vue?vue&type=style&index=0&id=c74f24ec&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74f24ec"]])

export default __exports__